export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export const THRESHOLD_TYPES = [
  { value: "PercentageElapsed", label: "Percentage Elapsed" },
  { value: "MinutesAfterBreach", label: "Minutes After Breach" },
];

export const NOTIFICATION_TYPES = [
  { value: "AboutToBreach", label: "About To Breach" },
  { value: "Breach", label: "Breach" },
  { value: "BreachEscalation", label: "Breach Escalation" },
];

export const OLA_NOTIFICATION_TYPES = [
  { value: "NewTicketCreated", label: "New Ticket Created" },
  {
    value: "AgentAssignedTicketToHimself",
    label: "Agent Assigned Ticket To Himself",
  },
];

export const EVENT_CATEGORIES = [
  { value: "SLA", label: "SLA" },
  // { value: "OLA", label: "OLA" },
];

export const SLA_ASSIGNMENT_GROUPS = [
  { name: "All" },
  { name: "FLM-Dubai" },
  { name: "FLM-Al Ain" },
  { name: "FLM-Northern Emirates" },
  { name: "FLM-Abu Dhabi" },
  { name: "SLM-Gunnebo" },
  { name: "FE-Cheque Collection Team Dubai" },
  { name: "Cash Operations-Abu Dhabi" },
  { name: "Cash Operations-Dubai" },
  { name: "Cash Operations-Al Ain" },
  { name: "Cash Operations-Northern Emirates" },
];

export const OLA_ASSIGNMENT_GROUPS = [
  { name: "All" },
  { name: "FLM-Dubai" },
  { name: "FLM-Al Ain" },
  { name: "FLM-Northern Emirates" },
  { name: "FLM-Abu Dhabi" },
  { name: "SLM-Gunnebo" },
  { name: "FE-Cheque Collection Team Dubai" },
  { name: "Cash Operations-Abu Dhabi" },
  { name: "Cash Operations-Dubai" },
  { name: "Cash Operations-Al Ain" },
  { name: "Cash Operations-Northern Emirates" },
  { name: "Call Center" },
  { name: "Cash Admin" },
  { name: "Planning & Analysis" },
  { name: "Security & Compliance" },
  { name: "EK Outsource" },
  { name: "Fleet Management" },
  { name: "TG Cash Customer Service" },
  { name: "CMC Operations-Abu Dhabi" },
  { name: "CMC Operations-Dubai" },
  { name: "Business Development" },
];

export const NOTIFICATION_CHANNELS = [{ id: "Email", text: "Email" }];

export const WHEN_SENT_OPTIONS = [
  { value: "NotAssigned", label: "Not Assigned" },
  { value: "NotAcknowledge", label: "Not Acknowledge" },
  { value: "TaskCompeleted", label: "Task Completed" },
];

export const NOTIFICATION_TRIGGER = [
  { value: "NotAssigned", label: "Not Assigned" },
  { value: "NotStarted", label: "Not Started" },
];

export const ESCALATION_LEVELS = [
  { id: 1, text: "Level 1" },
  { id: 2, text: "Level 2" },
  { id: 3, text: "Level 3" },
  { id: 4, text: "Level 4" },
  { id: 5, text: "Level 5" },
];
